import { createAction, handleActions, Action } from 'redux-actions'
import {
  GET_DISTRICTS_SUCCESS,
  GET_SCHOOLS_SUCCESS
} from '../../sagas/districtSchool/districtSchoolSaga'
// Name Spaced Action Types
const UPDATE_DISTRICT_SUGGESTIONS = 'AutoSuggest/UPDATE_DISTRICT_SUGGESTIONS'
const UPDATE_SCHOOL_SUGGESTIONS = 'AutoSuggest/UPDATE_SCHOOL_SUGGESTIONS'
const RESET_SCHOOLS = 'AutoSuggest/RESET_SCHOOLS'
const SET_MOU = 'AutoSuggest/SET_MOU'
export const actions = {
  UPDATE_DISTRICT_SUGGESTIONS,
  UPDATE_SCHOOL_SUGGESTIONS,
  RESET_SCHOOLS,
  SET_MOU
}

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
type AutoSuggestActionCreators = {
  updateDistrictSuggestions: (array: Array<any>) => Action<Array<any>>,
  updateSchoolSuggestions: (array: Array<any>) => Action<Array<any>>,
  resetSchools: () => Action<>,
  setMou: (bool: boolean) => Action<boolean>
}

export const actionCreators: AutoSuggestActionCreators = {
  updateDistrictSuggestions: createAction(UPDATE_DISTRICT_SUGGESTIONS),
  updateSchoolSuggestions: createAction(UPDATE_SCHOOL_SUGGESTIONS),
  resetSchools: createAction(RESET_SCHOOLS),
  setMou: createAction(SET_MOU)
}

export type AutoSuggestState = {
  districts: Array<any>,
  districtSuggestions: Array<any>,
  schools: Array<any>,
  schoolSuggestions: Array<any>,
  hasMou: boolean
}

export const initialState: AutoSuggestState = {
  districts: [],
  districtSuggestions: [],
  schools: [],
  schoolSuggestions: [],
  hasMou: false
}

export default handleActions(
  {
    [UPDATE_DISTRICT_SUGGESTIONS]: (state, action: Action<Array>) => ({
      ...state,
      districtSuggestions: action.payload
    }),
    [GET_DISTRICTS_SUCCESS]: (state, action: Action<Array>) => ({
      ...state,
      districts: action.payload
    }),
    [UPDATE_SCHOOL_SUGGESTIONS]: (state, action: Action<Array>) => ({
      ...state,
      schoolSuggestions: action.payload
    }),
    [GET_SCHOOLS_SUCCESS]: (state, action: Action<Array>) => ({
      ...state,
      schools: action.payload
    }),
    [RESET_SCHOOLS]: (state, action: Action<>) => ({
      ...state,
      schools: []
    }),
    [SET_MOU]: (state, action: Action<boolean>) => ({
      ...state,
      hasMou: action.payload
    })
  },
  initialState
)

export const filterGradPlannerSchools = (schools) => {
  const filteredSchools = schools.filter(school => {
    // return school.high_school === true
    return school.is_school_active === true
  })
  return filteredSchools
}

export const filterRegistrationSchools = (schools) => {
  const filteredSchools = schools.filter(school => {
    // return school.high_school === true
    // return school.high_school === true
    return true
  })
  return filteredSchools
}



// WEBPACK FOOTER //
// ./src/redux/reducers/autoSuggest/autoSuggestReducer.js